import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';

export default function SinAcceso({ onSalir, permiso }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3, bgcolor: '#f5f8fc' }}>
      <Paper variant="outlined" sx={{ p: 4, borderRadius: 4, textAlign: 'center', maxWidth: 560 }}>
        <Typography variant="h5" fontWeight={900}>Acceso POS no autorizado</Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          La empresa o perfil seleccionado no tiene el permiso <code>{permiso}</code>.
        </Typography>
        <Button variant="contained" sx={{ mt: 3 }} onClick={onSalir}>Cerrar sesión</Button>
      </Paper>
    </Box>
  );
}
